export interface SaleLine {
  color: string | null;
  sizes: string[];
  regular: string;
  sale: string;
}

/** SanMar colours/sizes on sale right now, beside the regular cost. Shown to
 *  the rep only — the cost Flow uses stays the regular price (Stephanie
 *  2026-10-28: "option 2"). */
export function SupplierSaleNote({ lines, currency, className }: { lines?: SaleLine[]; currency: string; className?: string }) {
  if (!lines?.length) return null;
  const money = (v: string) => {
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(Number(v));
    } catch {
      return `$${Number(v).toFixed(2)}`;
    }
  };
  return (
    <div className={`max-w-md rounded-md border border-amber-200 bg-amber-50 px-3 py-2 ${className ?? ""}`} aria-label="On sale at the supplier">
      <p className="text-sm font-medium text-brown-500">On sale at the supplier now</p>
      <ul className="mt-1 space-y-0.5 text-sm tabular-nums text-brown-500">
        {lines.slice(0, 12).map((l) => (
          <li key={`${l.color}-${l.regular}-${l.sale}`}>
            {l.color ?? "All colours"}
            {l.sizes.length ? <span className="text-brown-300"> ({l.sizes.join(", ")})</span> : null}:{" "}
            <span className="font-medium">{money(l.sale)}</span> <span className="text-brown-300">regular {money(l.regular)}</span>
          </li>
        ))}
      </ul>
      {lines.length > 12 && <p className="text-xs text-brown-300">…and {lines.length - 12} more</p>}
      <p className="mt-1 text-xs text-brown-300">
        Costs stay at the regular price. Sales can end without notice — check with the supplier before quoting the sale price.
      </p>
    </div>
  );
}
